import { Dayjs } from "dayjs";

import apiService from "./digitalProgramApi";
import {
  digitalProgramsByServicesError,
  digitalProgramsByServicesLoading,
  digitalProgramsByServicesSuccess,
} from "./digitalProgramStateAction";
import { IProgramVersionSummaryModel } from "../../../types/types";

export function getActiveProgramByServices(
  dispatch: any,
  customerAccountId: number,
  serviceIds: number[],
  from: Dayjs,
  to: Dayjs
) {
  dispatch(digitalProgramsByServicesLoading());
  apiService.getActiveProgramByServices(customerAccountId, serviceIds, from, to).then(
    (progarms: IProgramVersionSummaryModel[] | null) =>
      dispatch(digitalProgramsByServicesSuccess(progarms ?? new Array<IProgramVersionSummaryModel>())),
    (error: any) => dispatch(digitalProgramsByServicesError())
  );
}

export function getProgramPreview(
  customerAccountId: number,
  serviceId: number,
  programVersionId: number,
  careTypeGroupId: number
) {
  return apiService.getProgramPreview(customerAccountId, serviceId, programVersionId, careTypeGroupId);
}

export function downloadProgramPreview(customerAccountId: number, serviceId: number, programVersionId: number) {
  return apiService.downloadProgram(customerAccountId, serviceId, programVersionId);
}

export function getCustomerServicesDigitalProgramsSummary(customerAccountId: number) {
  return apiService.getCustomerServicesNationalProgramsSummary(customerAccountId);
}

export function getServicesWithUpcomingDigitalPrograms(
  customerAccountId: number,
  address: string | undefined,
  take: number,
  skip: number
) {
  return apiService.getServicesWithUpcomingNationalPrograms(customerAccountId, address, take, skip);
}

export function getNationalProgramDays(customerAccountId: number, serviceId: number) {
  return apiService.getNationalProgramDays(customerAccountId, serviceId);
}

export function downloadFileById(fileId: number) {
  return apiService.downloadFileById(fileId);
}
